export const CheckoutUrlPerEnvironment = {
  staging: 'https://pay-staging.appcharge.com',
  sandbox: 'https://pay-sandbox.appcharge.com',
  production: 'https://pay.appcharge.com',
};
